import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function TrashIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6 7C6.55228 7 7 7.44772 7 8V12C7 12.5523 6.55229 13 6 13C5.44772 13 5 12.5523 5 12V8C5 7.44772 5.44772 7 6 7Z" />
        <path d="M11 8C11 7.44772 10.5523 7 10 7C9.44772 7 9 7.44772 9 8V12C9 12.5523 9.44772 13 10 13C10.5523 13 11 12.5523 11 12V8Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 3V2C4 0.89543 4.89543 0 6 0H10C11.1046 0 12 0.895431 12 2V3H15C15.5523 3 16 3.44772 16 4C16 4.55228 15.5523 5 15 5V14C15 15.1046 14.1046 16 13 16H3C1.89543 16 1 15.1046 1 14V5C0.447715 5 0 4.55228 0 4C0 3.44772 0.447715 3 1 3H4ZM6 2H10V3H6V2ZM3 5V14H13V5H3Z"
        />
      </svg>
    </Icon>
  );
}
